import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg viewBox="0 0 1008 1008" {...this.props}><path fill="currentColor" d="M432 936h504V576H702q-22 0-38-16t-16-38V288H432v648zm144-810V90q0-8-5-13t-13-5H162q-8 0-13 5t-5 13v36q0 8 5 13t13 5h396q8 0 13-5t5-13zm144 378h168L720 336v168zm288 72v378q0 22-16 38t-38 16H414q-22 0-38-16t-16-38v-90H54q-22 0-38-16T0 810V54q0-22 16-38T54 0h612q22 0 38 16t16 38v185q12 7 20 15l230 230q16 16 27 43t11 49z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./app/javascript/components/icons/Copy.js